<template>
    <!-- 时间线组件 -->
    <el-timeline 
    :hide-timestamp="hideTime"
    :reverse="reverse"
    :placement="placement"
    >
        <el-timeline-item
        v-for="(tl,tinx) in timeLineList"
        :key="tl.time + tinx"
        :icon="tl.icon"
        :type="tl.type"
        :color="tl.color"
        :size="tl.size"
        :timestamp="tl.time"
        >
            <slot v-if="tl.slot" :name="tl.slot" :row="tl"></slot>
            <span v-else>{{tl.text}}</span>
        </el-timeline-item>
    </el-timeline>
</template>
<script>
export default {
    name:"VelTimeLine",
    props:{
        isReverse:Boolean,
        isHideTime:Boolean,
        placement:String,
        timeLineList:{
            type:Array,
            required:true,
        }
    },
    data() {
        return {
            reverse:false,
            hideTime:false,
        };
    },
    created() {
        this.initDataFn()
    },
    methods: {
        initDataFn(){
            this.isReverse ? this.reverse = true : this.reverse
            this.isHideTime ? this.hideTime = true : this.hideTime
        }
    }
}
</script>